module.exports = __webpack_public_path__ + "img/c1.742362ec.png";